import React from 'react';
import { EditableInfo } from '@icoach/components';

const SpecialBodyConditionBox = ({ className, specialBodyCondition, onEdit }) => {
    return (
        <EditableInfo label="身體特殊狀況" onEdit={onEdit} className={className} isMultiline>
            {specialBodyCondition || <span className={'font-color-4'}>無相關資料</span>}
        </EditableInfo>
    );
};

export default SpecialBodyConditionBox;
